import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Dropdown, Divider } from "antd";
import { Link } from "react-router-dom";
import { fetchData } from "../../../features/dropdown/dropdownSlice";
import { save } from "../../../features/save/saveSlice";
import useModalToggle from "../../../custom_hooks/useModalToggle";
import EmploymentTermsAdd from "./modal/EmploymentTermsAdd";
import toast from "react-hot-toast";
import Search from "../../../components/Search";
import ConfirmModal from "../../../components/ConfirmModal";
import CardLoading from "../../../components/CardLoading";
import InsideHeader from "../../../components/InsideHeader";
import svg76 from "../../../assets/svg/svg76.svg";
import svg27 from "../../../assets/svg/svg27.svg";
import svg96 from "../../../assets/svg/svg96.svg";
import svg97 from "../../../assets/svg/svg97.svg";

function EmploymentTermsTable() {
  const dispatch = useDispatch();
  const url = "v1/ap/terms-of-employment/terms-of-employment";
  const [searchInput, setSearchInput] = useState("");
  const [prodd, setProdd] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const { open, handleOpen, handleCancel } = useModalToggle();

  const { loading, data, count } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
  }));
 
  const handleSearch = (e) => {
  setSearchInput(e.target.value);
  dispatch(fetchData({ url, ["termName"]: e.target.value || null })); 
};

 const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };


  const handleDelete = async () => {
 const res = await dispatch(save({ url: "v1/ap/terms-of-employment/delete/" + prodd?.["termId"] }));
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      setOpenDelete(false);
      fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async () => {
    handleOpen();
  };

  const handleAdd = () => {
    setProdd(null);
    handleOpen();
  };
   const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex gap-x-[.75rem] items-center py-[.5rem] font-dmSans"
        >
          <img src={svg96} alt="svg96"  className="w-4 h-4"/><span className="whitespace-nowrap">Edit</span> 
        </Link>
      ),
    },
    {
      key: "divider-1",
      type: "divider",
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleOpenDelete}
          className="flex gap-x-[.75rem] items-center py-[.5rem] font-dmSans"
        >
          <img src={svg97} alt="svg97" className="w-4 h-4" />
          <span className="whitespace-nowrap">Delete</span>
        </Link>
      ),
    },
    {
      key: "divider-2",
      type: "divider",
    },
  ];

  const columns = [
    { title: "#", dataIndex: "index", key: "index",  width:'5%', render: (_, __, i) => i + 1 },
    { title: "Name", dataIndex: "termName" },
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const fetchTableData = (page = pageIndex, size = pageSize) => {
    dispatch(fetchData({ url, start: page, limit: size }));
  };

  useEffect(() => { fetchTableData(); }, []);


  if (loading && !searchInput) return <CardLoading />;

  return (
    <div className="w-full h-full overflow-y-scroll"> 
      <InsideHeader title="Employment Terms" subtitle="Manage employment terms within your recruitment" back={false} />
      <div className="white_card mt-[1.25rem] min-h-[70vh] flex-1">
        <h3 className="font-[700] text-[24px] text-lightBlack dash-title">Employment Terms Setup</h3>
        <div className="flex flex-wrap items-center lg:justify-end justify-start gap-[.62rem]">
          <div className="lg:w-[16.125rem] w-full">
            <Search searchInput={searchInput} handleSearch={handleSearch} text="Search" />
          </div>
          <div className="w-[100px]">
            <button onClick={handleAdd} className="cstm-btn">
              <img src={svg76} alt="add" />
              <span className="ml-1">Add</span>
            </button>
          </div>
        </div>
        {loading ? <CardLoading /> : (
          <Table
            className="mt-[1.31rem] w-full"
            scroll={{ x: "auto" }}
            rowKey={(record) => record?.termId}
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomCenter"],
              current: pageIndex + 1,
              total: count,
              pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        )}
      </div>

      <EmploymentTermsAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />

      <ConfirmModal
       open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default EmploymentTermsTable;